<template>
    <span>
        <a v-if="isEdit == false" class="btn btn-primary btn-sm" @click="openModal">
            <i class="fa fa-plus"></i> Add Defects
        </a>
        <a v-if="isEdit == true" class="btn btn-primary btn-sm btn-circle" @click="openEditModal">
            <i class="fa fa-edit"></i>
        </a>
        <b-modal
            :id="'defectformmodal'+ modalId"
            :title="formModal.title"
            @hidden="resetModal"
            @ok="handleSubmit"
            ok-title="Submit"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit" novalidate>

                <b-form-group label="Label" label-for="label-input">
                    <b-form-input id="label-input" v-model="form.label"></b-form-input>
                </b-form-group>

                <b-form-group label="Context Helper" label-for="context_helper-input">
                    <b-form-textarea id="context_helper-input" v-model="form.context_helper"></b-form-textarea>
                </b-form-group>

                <b-form-group label="Sample Image">
                    <div v-if="existingSampleImage && !removeSampleImage" class="mb-2">
                        <img :src="existingSampleImage" class="img-thumbnail mb-1" style="max-height: 100px; cursor: zoom-in;" @click="$refs.lightbox.open(existingSampleImage, { title: form.label })">
                        <div>
                            <b-form-checkbox v-model="removeSampleImage" switch>Remove image</b-form-checkbox>
                        </div>
                    </div>
                    <photo-source-picker
                        :desktop-label="existingSampleImage && !removeSampleImage ? 'Replace image' : 'Choose image'"
                        @selected="file => sampleImageFile = file"
                    />
                    <div v-if="sampleImageFile" class="small text-success mt-1">
                        <i class="las la-check-circle"></i> {{ sampleImageFile.name }}
                    </div>
                    <small class="text-muted">Shown to owner as a reference when selecting this defect.</small>
                </b-form-group>

            </form>
            <image-lightbox ref="lightbox" />
        </b-modal>
    </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    props:['componentId', 'groupId', 'formData', 'isEdit', 'modalId'],
    data(){
        return this.initData();
    },
    validations: {
        form: {
            label: { required }
        }
    },
    methods: {
        initData(){
            return {
                form:{
                    label: null,
                    context_helper: null
                },
                formModal:{
                    title: null
                },
                language: 'en',
                sampleImageFile: null,
                existingSampleImage: null,
                removeSampleImage: false,
            }
        },
        openModal(){
            this.formModal.title = "Create Defect";
            this.$bvModal.show('defectformmodal' + this.modalId);
        },
        openEditModal(){
            this.formModal.title = "Edit Defect";
            this.form = JSON.parse(JSON.stringify(this.formData));
            this.existingSampleImage = this.formData.sample_image_url || null;
            this.$bvModal.show('defectformmodal' + this.modalId);
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if(this.isEdit == true){
                this.submitUpdate();
            }else{
                this.submitSave();
            }
        },
        buildFormData(){
            const fd = new FormData();
            fd.append('language', this.language);
            fd.append('label', this.form.label || '');
            fd.append('context_helper', this.form.context_helper || '');
            if (this.sampleImageFile) {
                fd.append('sample_image', this.sampleImageFile);
            }
            if (this.removeSampleImage) {
                fd.append('remove_sample_image', '1');
            }
            return fd;
        },
        async submitSave(){
            try {
                await axios.post(
                    route("admin.houses.components.groups.defects.store", [this.componentId, this.groupId]),
                    this.buildFormData()
                );
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('defectformmodal' + this.modalId);
                this.$emit('update-list')
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        async submitUpdate(){
            try {
                const fd = this.buildFormData();
                fd.append('_method', 'PUT');
                await axios.post(
                    route("admin.houses.components.groups.defects.update", [this.componentId, this.groupId, this.formData.id]),
                    fd
                );
                this.$swal('Updated!', '', 'success');
                this.$bvModal.hide('defectformmodal' + this.modalId);
                this.$emit('update-list')
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        resetModal(){
            Object.assign(this.$data, this.initData());
            this.$nextTick(() => { this.$v.$reset(); });
        },
    }
}

</script>
